import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext } from 'react';
import { StatsigClient } from '../statsig-client';
import { jsx as _jsx } from "react/jsx-runtime";
export const StatsigContext = /*#__PURE__*/createContext({
  statsigClient: new StatsigClient() // without init it will return only falsy or default value. its required so that consumer does has to put a check for undefined
});
export function useStatsig() {
  const context = useContext(StatsigContext);
  if (context === undefined) {
    console.error('useStatsig must be used within a StatsigProvider');
  }
  return context.statsigClient;
}
export function withStatsig(Component) {
  return function StatsigComponent(props) {
    return /*#__PURE__*/_jsx(StatsigContext.Consumer, {
      children: _ref => {
        let {
          statsigClient
        } = _ref;
        return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
          statsigClient: statsigClient
        }));
      }
    });
  };
}